import React, { useEffect } from 'react'
import ErrorBox from './ErrorBox'

export default ({ title, message, hidden }) => {
  useEffect(() => {
    !hidden && document.getElementById('empty-placeholder').focus()
  }, [title, message, hidden])
  return (
    <div
      tabIndex={-1}
      id="empty-placeholder"
      role="alert"
      aria-live="assertive"
      className="empty-placeholder-wrapper error"
      style={{ display: hidden ? 'none' : 'flex' }}>
      <ErrorBox />
      <h3>{title || 'An error has occurred.'}</h3>
      <p>{message || 'Please try your search again, and contact support if the problem persists.'}</p>
    </div>
  )
}